// import { pauseGaanaPlayer } from 'modules/WithGaanaWidget/utils';
import { videoIframeTemplate, miniTVIframeTemplate } from '../../config/public';
import { getSiteDomain } from '../../utils/common';

export const generateIframeUrl = function generateIframeUrl(msid) {
  return `${getSiteDomain()}/${videoIframeTemplate()}?msid=${msid}`;
};
function currentPlayer(conEl) {
  if (typeof window !== 'undefined' && window.player) {
    if (Array.isArray(window.player)) {
      if (conEl) {
        return window.player.find(
          item => item.store.clientConfig.contEl === conEl,
        );
      }
      return window.player[0];
    }
    return window.player;
  }
  return null;
}
export function getVideoItemFromMediaInfoFeed({
  title,
  description,
  totalcount,
  // duration,
  timestamp,
  agency,
  seopath,
  msid,
  path = '',
  embedId,
}) {
  return {
    hl: title,
    des: description,
    views: totalcount,
    lpt: timestamp,
    agency,
    wu: `https://timesofindia.indiatimes.com/${seopath}/videoshow/${msid}.cms`,
    id: msid,
    path,
    embedId,
  };
}

export const generateMiniTvIframeUrl = function generateMiniTvIframeUrl(
  slikeid,
) {
  return `${getSiteDomain()}/${miniTVIframeTemplate()}?stream_id=${slikeid}&source=mini_tv`;
};

export function getVideoImg(msid, imgsize) {
  return `https://static.toiimg.com/thumb/imgsize-${imgsize},msid-${msid},width-1200,resizemode-4/${msid}.jpg`;
}

export const getPlaylistUrl = ({ msid, secid }) =>
  __PROD__
    ? `https://timesofindia.indiatimes.com/videpostroll_v7.cms?
feedtype=json&callback=cached&msid=${msid}&secid=${secid}`
    : `https://toidev.indiatimes.com/videpostroll_v7.cms?
feedtype=json&callback=cached&msid=${msid}&secid=${secid}`;

/* @todo
    create a list of players in redux,
    each player would have name and pause function,
    when one player plays it should dispatch an action which has its name
    and we write code to pause other players with name !== current player
    also actions to add delete player should be there
*/
export function resumePlayer(conEl) {
  const player = currentPlayer(conEl);
  setTimeout(() => {
    if (player && typeof player.play === 'function') {
      try {
        player.play();
      } catch (error) {
        //
      }
    }
  }, 100);
}
export function pausePlayer() {
  setTimeout(() => {
    if (
      typeof window !== 'undefined' &&
      window.player &&
      window.player.length > 0
    ) {
      window.player.forEach((item, index) => {
        window.player[index].pause();
      });
    } else if (
      typeof window !== 'undefined' &&
      window.player &&
      typeof window.player.pause === 'function'
    ) {
      try {
        window.player.pause();
      } catch (error) {
        //
      }
    }
  }, 100);
}
export function destroyPlayer() {
  setTimeout(() => {
    if (
      typeof window !== 'undefined' &&
      window.player &&
      typeof window.player.destroy === 'function'
    ) {
      try {
        window.player.destroy();
      } catch (error) {
        //
      }
    }
  }, 100);
}
export function pauseOtherPlayers() {
  // pauseGaanaPlayer();
}
// setVolume and mute functions user initiated functions,
// initial volume and mute is set by player.js by passing proper parameters to it.
// TOIPR-56068

export function setVolume(value) {
  try {
    if (
      window.S &&
      window.S.activePlayer &&
      typeof window.S.activePlayer.setVolume === 'function'
    ) {
      window.S.activePlayer.setVolume(value);
    }
  } catch (error) {
    //
  }
}

export function mute(value, conEl) {
  try {
    const player = currentPlayer(conEl);
    if (value && player && typeof player.mute === 'function') {
      player.mute();
    } else if (!value && player && typeof player.unmute === 'function') {
      player.unmute();
    }
  } catch (error) {
    //
  }
}
export function setPlayerHeadless(headParam, conEl) {
  try {
    const player = currentPlayer(conEl);
    if (
      player &&
      player.setPlayerHeadless &&
      typeof player.setPlayerHeadless === 'function'
    ) {
      player.setPlayerHeadless(headParam);
    }
  } catch (error) {
    //
  }
}
export default { generateIframeUrl };
